import React, { useState, useEffect } from 'react';
import axios from 'axios';
function auth() { return { headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } }; }
const DEF = { name:'', description:'', type:'circle', geometry:{ lat:0, lng:0, radiusMeters:1000 }, onEnter:{ notify:true }, onExit:{ notify:false }, active:true };

export default function Geofencing({ user }) {
  const [fences, setFences] = useState([]);
  const [msg, setMsg] = useState({ text:'', type:'' });
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(DEF);
  const [saving, setSaving] = useState(false);

  function flash(t,type='success') { setMsg({text:t,type}); setTimeout(()=>setMsg({text:'',type:''}),4000); }
  useEffect(()=>{ axios.get('/api/geofencing',auth()).then(r=>setFences(r.data)).catch(()=>{}); },[]);

  async function save(e) {
    e.preventDefault(); setSaving(true);
    try { await axios.post('/api/geofencing',form,auth()); flash('Geofence created'); setShowForm(false); setForm(DEF); const r=await axios.get('/api/geofencing',auth()); setFences(r.data); }
    catch(e) { flash(e.response?.data?.error||'Failed','error'); } finally { setSaving(false); }
  }
  async function del(id) { try{ await axios.delete(`/api/geofencing/${id}`,auth()); const r=await axios.get('/api/geofencing',auth()); setFences(r.data); flash('Deleted'); }catch{flash('Failed','error');} }

  function updateGeo(k,v) { setForm(f=>({ ...f, geometry:{...f.geometry,[k]:parseFloat(v)||0} })); }

  return (
    <div style={{padding:24}}>
      {msg.text&&<div style={{padding:'10px 16px',borderRadius:8,marginBottom:16,background:msg.type==='error'?'#fee2e2':'#dcfce7',color:msg.type==='error'?'#dc2626':'#16a34a',fontWeight:600}}>{msg.type==='error'?'✘':'✔'} {msg.text}</div>}
      <div style={{display:'flex',justifyContent:'space-between',marginBottom:24}}>
        <div><h2 style={{margin:0,fontSize:20,fontWeight:700}}>Geofencing</h2><p style={{margin:'4px 0 0',color:'#64748b',fontSize:14}}>Location-based compliance policies — trigger actions when devices enter or leave zones</p></div>
        <button onClick={()=>setShowForm(true)} style={{background:'#1e40af',color:'#fff',border:'none',borderRadius:8,padding:'10px 20px',fontWeight:600,cursor:'pointer'}}>+ New Geofence</button>
      </div>
      <div style={{background:'#fefce8',border:'1px solid #fef08a',borderRadius:10,padding:'12px 16px',marginBottom:20,fontSize:13}}>
        <span style={{fontWeight:700,color:'#a16207'}}>📍 How it works: </span>Agents report their location via <code>/api/geofencing/checkin</code>. When a device enters or exits a defined zone, configured actions fire automatically.
      </div>
      {fences.length===0 ? (
        <div style={{textAlign:'center',padding:60,color:'#94a3b8'}}><div style={{fontSize:40}}>📍</div><div style={{fontWeight:600,marginTop:12}}>No geofences defined</div><div style={{fontSize:14,marginTop:8}}>Create circular or polygon zones to enforce location-based policies</div></div>
      ) : (
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(340px,1fr))',gap:14}}>
          {fences.map(f=>(
            <div key={f.id} style={{background:'#fff',border:'1px solid #e2e8f0',borderRadius:12,padding:18}}>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:10}}>
                <div><div style={{fontWeight:700,fontSize:14}}>{f.name}</div><div style={{fontSize:12,color:'#64748b'}}>{f.type} · {f.active?'Active':'Inactive'}</div></div>
                <span style={{fontSize:24}}>📍</span>
              </div>
              {f.description&&<div style={{fontSize:12,color:'#64748b',marginBottom:8}}>{f.description}</div>}
              <div style={{background:'#f8fafc',borderRadius:7,padding:'8px 10px',marginBottom:10,fontSize:11,color:'#475569'}}>
                {f.type==='circle'&&<div>Center: {f.geometry?.lat?.toFixed(4)}, {f.geometry?.lng?.toFixed(4)} · Radius: {f.geometry?.radiusMeters}m</div>}
                <div style={{marginTop:4}}>On Enter: {Object.keys(f.onEnter||{}).filter(k=>f.onEnter[k]).join(', ')||'—'}</div>
                <div>On Exit:  {Object.keys(f.onExit||{}).filter(k=>f.onExit[k]).join(', ')||'—'}</div>
              </div>
              <button onClick={()=>del(f.id)} style={{background:'#fee2e2',border:'none',borderRadius:6,padding:'6px 12px',fontSize:12,cursor:'pointer',color:'#dc2626',fontWeight:600}}>🗑 Delete</button>
            </div>
          ))}
        </div>
      )}
      {showForm&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:14,padding:32,width:500,maxWidth:'95vw',maxHeight:'85vh',overflow:'auto'}}>
            <h3 style={{margin:'0 0 20px',fontSize:18,fontWeight:700}}>New Geofence</h3>
            <form onSubmit={save}>
              {[['Name*','name'],['Description','description']].map(([l,k])=>(
                <div key={k} style={{marginBottom:14}}><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>{l}</label>
                  <input value={form[k]||''} onChange={e=>setForm({...form,[k]:e.target.value})} required={l.includes('*')} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} /></div>
              ))}
              <div style={{marginBottom:14}}><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Type</label>
                <select value={form.type} onChange={e=>setForm({...form,type:e.target.value})} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14}}>
                  <option value="circle">Circle (center + radius)</option>
                  <option value="polygon">Polygon (coordinates)</option>
                </select></div>
              {form.type==='circle'&&(
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:10,marginBottom:14}}>
                  {[['Latitude','lat'],['Longitude','lng'],['Radius (m)','radiusMeters']].map(([l,k])=>(
                    <div key={k}><label style={{display:'block',fontWeight:600,fontSize:12,marginBottom:3}}>{l}</label>
                      <input type="number" step="any" value={form.geometry?.[k]||0} onChange={e=>updateGeo(k,e.target.value)} style={{width:'100%',padding:'8px 10px',border:'1px solid #d1d5db',borderRadius:7,fontSize:13,boxSizing:'border-box'}} /></div>
                  ))}
                </div>
              )}
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:20}}>
                {[['On Enter','onEnter'],['On Exit','onExit']].map(([l,k])=>(
                  <div key={k} style={{background:'#f8fafc',borderRadius:8,padding:12}}>
                    <div style={{fontWeight:600,fontSize:12,marginBottom:8,color:'#374151'}}>{l}</div>
                    {[['notify','Send notification'],['message','Show device message']].map(([ak,al])=>(
                      <label key={ak} style={{display:'flex',gap:6,fontSize:12,marginBottom:4,cursor:'pointer'}}>
                        <input type="checkbox" checked={!!(form[k]||{})[ak]} onChange={e=>setForm(f=>({...f,[k]:{...f[k],[ak]:e.target.checked}}))} />{al}
                      </label>
                    ))}
                  </div>
                ))}
              </div>
              <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
                <button type="button" onClick={()=>setShowForm(false)} style={{padding:'10px 20px',border:'1px solid #d1d5db',borderRadius:8,background:'#fff',cursor:'pointer',fontWeight:600}}>Cancel</button>
                <button type="submit" disabled={saving} style={{padding:'10px 20px',background:saving?'#94a3b8':'#1e40af',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:saving?'default':'pointer'}}>{saving?'Creating...':'Create'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
